import React from 'react'
import PopupMenuButton from "../../../../../core/gd-components/popover-menu/popup-menu-button/popup-menu-button"
import AiAgentPopupMenu from "./popup-menu/agent-popup-menu"
import AiChatModule from "../../../../../core/gd-modules/ai-chat/ai-chat"
import AiAgentAvatar from "../../agent-avatar"
import {DEFAULT_AGENT_ID} from "../../../../settings/ai/agents/list/default-agent"


type Props = {
    module      : AiChatModule
    onSelect    : (agentId: ID | null) => void
}

export default function AiAgentSelector(props: Props) {

    const renderButton = () => {
        const agentId = props.module.agentId ?? DEFAULT_AGENT_ID

        return (
            <>
                <div className="agent-btn-avatar">
                    <AiAgentAvatar agentId={agentId} size={24}/>
                </div>
                <div className="agent-btn-chevron i5-big-angle-down"/>
            </>
        )
    }

    return (
        <PopupMenuButton
            className                  = "ui5-control-button agent-selector-btn gray"
            hint                       = "AI Agent"
            attachment                 = "top left"
            targetAttachment           = "bottom left"
            offset                     = "0 0"
            disabled                   = {false}
            btnComponent               = {renderButton}
            outsideClickIgnoreClasses  = {['more-menu']}
            popoverClass               = "ignore-react-onclickoutside"
            menuComponent              = {AiAgentPopupMenu}
            menuParams = {{
                currentAgentId : props.module.agentId,
                onSelect       : props.onSelect,
            }}/>
    )
}
